export default "__VITE_ASSET__Dv5N$csl__"